import { Stack, styled, Typography } from "@mui/material";
import { black } from "@/theme/colors";
import { CaseTagStatus } from "@/features/case/components/CaseTagStatus";
import { CASE_STATUS } from "@/features/case/constants/caseStatus";
import { FCC } from "@/types/common";
import { EMPTY_STR } from "@/constants/string";
import { TGetJobDto } from "@/api/services/main/job/dtos/get-job.dto";
import dayjs from "dayjs";
import { DATE_FORMAT } from "@/constants/datetime";

type CaseTitleProps = {
  jobInfo: TGetJobDto;
};

export const CaseTitle: FCC<CaseTitleProps> = ({ jobInfo }) => {
  return (
    <TitleContainer>
      <Stack direction="row" alignContent="end" alignItems="end" gap={2} mb={4} flexWrap="wrap">
        <Typography color={black[30]} variant="head24Bold" sx={{ wordBreak: "break-word", maxWidth: "100%" }}>
          {jobInfo.jobName} - {jobInfo.company?.managementNumber}
        </Typography>
        <CaseTagStatus status={CASE_STATUS.PREPARING_PROPOSAL} />
      </Stack>
      <Stack direction="row" alignContent="end" alignItems="end" gap={2} flexWrap="wrap">
        <Typography color={black[70]} variant="body14Light" sx={{ wordBreak: "break-word" }}>
          案件管理番号: {jobInfo.company?.managementNumber ?? EMPTY_STR.TEXT}
        </Typography>
        <Typography color={black[70]} variant="body14Light" sx={{ wordBreak: "break-word" }}>
          企業名：{jobInfo.company?.companyName ?? EMPTY_STR.TEXT}
        </Typography>
        <Typography color={black[70]} variant="body14Light" sx={{ wordBreak: "break-word" }}>
          案件開始日：{dayjs(jobInfo.createdAt).format(DATE_FORMAT) ?? EMPTY_STR.TEXT}
        </Typography>
        {/* <Typography color={black[70]} variant="body14Light">
          候補者: 3名（うち内定受諾者：1名）: feature matches_case
        </Typography> */}
      </Stack>
    </TitleContainer>
  );
};

const TitleContainer = styled(Stack)`
  width: 1134px;
  min-height: 89px;
  justify-content: space-between;
  opacity: 1;
`;
